var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("SearchTerm", {
        attrs: {
          searchInfo: _vm.searchInfo,
          searchMore: false,
          searchBaseItems: [],
          btns: { search: true, reset: true }
        },
        on: { onChange: function() {} }
      }),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "div",
        { staticClass: "bairun-table-btns" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
            [_vm._v("新增盘点")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            height: "45rem",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ID", width: "40", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { label: "便利店名称", prop: "sellerId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.allStationMap[String(scope.row.sellerId)]
                          .stationName
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "盘点编号", prop: "checkNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "盘点名称", prop: "checkName" }
          }),
          _c("el-table-column", {
            attrs: { label: "商品种类", prop: "categoryNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "库存数量", prop: "goodsNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "盘点数量", prop: "checkNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "数量盈亏", prop: "differenceNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "金额盈亏", prop: "differenceAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "审批人", prop: "auditUserName" }
          }),
          _c("el-table-column", {
            attrs: { label: "审批时间", prop: "auditAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDateTime")(scope.row.auditAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "审核状态", prop: "auditStatus", width: "80px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", effect: "plain" } },
                          [_vm._v("未提交")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", effect: "plain" } },
                          [_vm._v("审核中")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("通过")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 4
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("不通过")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt", width: "160px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatDateTime")(scope.row.CreatedAt))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "280px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onViewQrcode(scope.row)
                          }
                        }
                      },
                      [_vm._v("盘点码")]
                    ),
                    scope.row.auditStatus >= 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onExport(scope.row)
                              }
                            }
                          },
                          [_vm._v("导出")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "warning" },
                            on: {
                              click: function($event) {
                                return _vm.onAudit(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-dropdown",
                          {
                            attrs: { size: "small", trigger: "click" },
                            on: { command: _vm.handleMoreCommand }
                          },
                          [
                            _c("el-button", [
                              _vm._v("更多"),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                scope.row.auditStatus == 1
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          icon: "el-icon-cpu",
                                          command: {
                                            triggle: "onUpdate",
                                            params: scope.row
                                          }
                                        }
                                      },
                                      [_vm._v("继续盘点")]
                                    )
                                  : _vm._e(),
                                scope.row.auditStatus == 1
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          icon: "el-icon-cpu",
                                          command: {
                                            triggle: "onSubmitAudit",
                                            params: scope.row
                                          }
                                        }
                                      },
                                      [_vm._v("提审")]
                                    )
                                  : _vm._e(),
                                scope.row.auditStatus == 1
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          icon: "el-icon-cpu",
                                          command: {
                                            triggle: "onDelete",
                                            params: scope.row
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            title:
              (_vm.type == "view"
                ? "查看明细："
                : _vm.type == "submit"
                ? "提交审核："
                : _vm.type == "audit"
                ? "审核操作："
                : _vm.type == "update"
                ? "继续盘点（注意：【盈亏金额】按最新成本单价计算）"
                : "") +
              (_vm.goodsCheckDetailTableData[0]
                ? _vm.allStationMap[
                    String(_vm.goodsCheckDetailTableData[0].sellerId)
                  ].stationName +
                  "-" +
                  _vm.goodsCheckDetailTableData[0].checkNo
                : ""),
            visible: _vm.viewAndAuditdialogVisible,
            "custom-class": "bairun-dialog check-dialog bairun-dialog-large",
            "before-close": _vm.closeDialog,
            "element-loading-text": _vm.loadingText,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "#0000004d"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewAndAuditdialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "bianlidian-check-search search-term" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, model: _vm.checkSearchInfo }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "扫条码" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请扫条码", clearable: "" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.onCheckSubmit.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.checkSearchInfo.goodsNo,
                          callback: function($$v) {
                            _vm.$set(_vm.checkSearchInfo, "goodsNo", $$v)
                          },
                          expression: "checkSearchInfo.goodsNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "搜索条件", clearable: "" },
                        model: {
                          value: _vm.checkSearchInfo.goodsName,
                          callback: function($$v) {
                            _vm.$set(_vm.checkSearchInfo, "goodsName", $$v)
                          },
                          expression: "checkSearchInfo.goodsName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否盈亏" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.checkSearchInfo.isDifference,
                            callback: function($$v) {
                              _vm.$set(_vm.checkSearchInfo, "isDifference", $$v)
                            },
                            expression: "checkSearchInfo.isDifference"
                          }
                        },
                        [
                          _c("el-option", {
                            key: 1,
                            attrs: { label: "是", value: 1 }
                          }),
                          _c("el-option", {
                            key: 2,
                            attrs: { label: "否", value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "盘点状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.checkSearchInfo.isChecked,
                            callback: function($$v) {
                              _vm.$set(_vm.checkSearchInfo, "isChecked", $$v)
                            },
                            expression: "checkSearchInfo.isChecked"
                          }
                        },
                        [
                          _c("el-option", {
                            key: 1,
                            attrs: { label: "已盘", value: 1 }
                          }),
                          _c("el-option", {
                            key: 2,
                            attrs: { label: "未盘", value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onCheckSubmit }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", { on: { click: _vm.onCheckReset } }, [
                        _vm._v("重置")
                      ])
                    ],
                    1
                  ),
                  _vm.type == "update"
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onSetPageCheck } },
                            [_vm._v("设置本页为已盘")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("el-pagination", {
            style: { float: "right", padding: "20px" },
            attrs: {
              "current-page": _vm.checkPageInfo.page,
              "page-size": _vm.checkPageInfo.pageSize,
              "page-sizes": [10, 20, 30, 50, 100],
              "pager-count": 3,
              total: _vm.checkPageInfo.total,
              layout: "total, sizes, prev, pager, next"
            },
            on: {
              "current-change": _vm.handleCheckDialogCurrentChange,
              "size-change": _vm.handleCheckDialogSizeChange
            }
          }),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.goodsCheckDetailTableData,
                border: "",
                stripe: "",
                "tooltip-effect": "dark"
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "商品名称", prop: "goodsName" }
              }),
              _c("el-table-column", {
                attrs: { label: "库存数量", prop: "goodsStock" }
              }),
              _c("el-table-column", {
                attrs: { label: "盘点数量", prop: "checkNum" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.type == "update"
                          ? _c("el-input-number", {
                              staticClass: "bairun-input-fill",
                              staticStyle: { height: "47px" },
                              attrs: {
                                min: 0,
                                placeholder: "盘点数量",
                                "controls-position": "right",
                                clearable: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleSingleUpdate(scope.row)
                                },
                                input: function($event) {
                                  return _vm.onInputCheckNum(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.checkNum,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "checkNum", $$v)
                                },
                                expression: "scope.row.checkNum"
                              }
                            })
                          : _c("div", [_vm._v(_vm._s(scope.row.checkNum))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "数量盈亏", prop: "differenceNum" }
              }),
              _c("el-table-column", {
                attrs: { label: "金额盈亏", prop: "differenceAmount" }
              }),
              _c("el-table-column", {
                attrs: { label: "盈亏说明", prop: "differenceRemark" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.type == "update"
                          ? _c("el-input", {
                              staticClass: "bairun-input-fill",
                              staticStyle: { height: "47px" },
                              attrs: {
                                type: "text",
                                placeholder: "盈亏原因说明",
                                clearable: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleSingleUpdate(scope.row)
                                },
                                input: function($event) {
                                  return _vm.inputChange($event)
                                }
                              },
                              model: {
                                value: scope.row.differenceRemark,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "differenceRemark", $$v)
                                },
                                expression: "scope.row.differenceRemark"
                              }
                            })
                          : _c("div", [
                              _vm._v(_vm._s(scope.row.differenceRemark))
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "最新成本价", prop: "goodsLatestCost" }
              }),
              _c("el-table-column", {
                attrs: { label: "盘点状态", prop: "isChecked" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.type == "update"
                          ? _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                on: {
                                  change: function($event) {
                                    return _vm.handleSingleUpdate(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.isChecked,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "isChecked", $$v)
                                  },
                                  expression: "scope.row.isChecked"
                                }
                              },
                              [
                                _c("el-option", {
                                  key: 0,
                                  attrs: { label: "未盘", value: 0 }
                                }),
                                _c("el-option", {
                                  key: 1,
                                  attrs: { label: "已盘", value: 1 }
                                })
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                scope.row.isChecked == 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { type: "info", effect: "plain" }
                                      },
                                      [_vm._v("未盘")]
                                    )
                                  : _vm._e(),
                                scope.row.isChecked == 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          effect: "plain"
                                        }
                                      },
                                      [_vm._v("已盘")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.type == "view"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "viewForm",
                    staticStyle: { "margin-top": "10px" },
                    attrs: { model: _vm.formData, "label-position": "right" }
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "盈亏说明:",
                                  prop: "differenceRemark"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formData.differenceRemark) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "审批意见:",
                                  prop: "auditRemark"
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.formData.auditRemark) + " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "审批结果:",
                                  prop: "auditStatus"
                                }
                              },
                              [
                                _vm.formData.auditStatus == 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { type: "info", effect: "plain" }
                                      },
                                      [_vm._v("未提交")]
                                    )
                                  : _vm._e(),
                                _vm.formData.auditStatus == 2
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "warning",
                                          effect: "plain"
                                        }
                                      },
                                      [_vm._v("审核中")]
                                    )
                                  : _vm._e(),
                                _vm.formData.auditStatus == 3
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          effect: "plain"
                                        }
                                      },
                                      [_vm._v("通过")]
                                    )
                                  : _vm._e(),
                                _vm.formData.auditStatus == 4
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "error",
                                          effect: "plain"
                                        }
                                      },
                                      [_vm._v("不通过")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.type == "audit"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "auditForm",
                    staticStyle: { "margin-top": "10px" },
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.auditRules,
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: _vm.isMobile ? 24 : 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "盈亏说明:",
                                  prop: "differenceRemark"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { type: "textarea" },
                                  on: {
                                    input: function($event) {
                                      return _vm.inputChange($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.formData.differenceRemark,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "differenceRemark",
                                        $$v
                                      )
                                    },
                                    expression: "formData.differenceRemark"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: _vm.isMobile ? 24 : 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "审批意见:",
                                  prop: "auditRemark"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.inputChange($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.formData.auditRemark,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "auditRemark", $$v)
                                    },
                                    expression: "formData.auditRemark"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: _vm.isMobile ? 24 : 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "审批结果:",
                                  prop: "auditStatus"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择"
                                    },
                                    model: {
                                      value: _vm.formData.auditStatus,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditStatus",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditStatus"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      key: 3,
                                      attrs: { label: "通过", value: 3 }
                                    }),
                                    _c("el-option", {
                                      key: 4,
                                      attrs: { label: "不通过", value: 4 }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.type == "submit"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "submitForm",
                    staticStyle: { "margin-top": "10px" },
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.submitRules,
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: _vm.isMobile ? 24 : 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "盈亏说明:",
                                  prop: "differenceRemark"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    clearable: "",
                                    placeholder: "请输入详细说明"
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.inputChange($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.formData.differenceRemark,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "differenceRemark",
                                        $$v
                                      )
                                    },
                                    expression: "formData.differenceRemark"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addDialogVisible,
            title: "新增计划",
            "element-loading-text": _vm.loadingText,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "#0000004d"
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.addRules,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "便利店", prop: "sellerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择"
                              },
                              model: {
                                value: _vm.formData.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "sellerId", $$v)
                                },
                                expression: "formData.sellerId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "计划名称:", prop: "checkName" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.checkName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "checkName", $$v)
                              },
                              expression: "formData.checkName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center", "margin-bottom": "30px" }
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.qrcodeDialogVisible,
            title: "微信扫码进行盘点"
          },
          on: {
            "update:visible": function($event) {
              _vm.qrcodeDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { span: 16 }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c("el-form-item", { attrs: { label: "便利店名称:" } }, [
                        _vm._v(_vm._s(_vm.formData.sellerName))
                      ]),
                      _c("el-form-item", { attrs: { label: "盘点计划:" } }, [
                        _vm._v(_vm._s(_vm.formData.checkName))
                      ]),
                      _c("el-form-item", { attrs: { label: "创建时间:" } }, [
                        _vm._v(_vm._s(_vm.formData.CreatedAt))
                      ])
                    ],
                    1
                  ),
                  _c("img", {
                    staticStyle: { width: "70%" },
                    attrs: { src: _vm.qrcodeText, alt: "" }
                  })
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("关闭")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }